import { LOBBY_DETAILS_STORAGE_KEY } from '@/constants';
import { createSlice } from '@reduxjs/toolkit';
import { useSelector } from 'react-redux';

export const initialState: any =
	typeof window !== 'undefined'
		? JSON.parse(localStorage.getItem(LOBBY_DETAILS_STORAGE_KEY) || 'null') || {}
		: {};

export const lobbyDetailsSlice = createSlice({
	name: 'lobbyDetails',
	initialState,
	reducers: {
		setLastKnownRank: (state: any, action: any) => {
			const { lobbyId, rank } = action.payload;
			if (!state[lobbyId]) {
				state[lobbyId] = { lastKnownRank: null };
			}
			state[lobbyId].lastKnownRank = rank;

			localStorage.setItem(LOBBY_DETAILS_STORAGE_KEY, JSON.stringify(state));
		},
		setShouldAnimate: (state: any, action: any) => {
			const { lobbyId, value } = action.payload;
			if (!state[lobbyId]) {
				state[lobbyId] = {};
			}
			state[lobbyId].isShouldAnimate = value;
			localStorage.setItem(LOBBY_DETAILS_STORAGE_KEY, JSON.stringify(state));
		},
		setSeenOpenMarketIds: (state: any, action: any) => {
			const { lobbyId, marketIds } = action.payload;
			if (!state[lobbyId]) {
				state[lobbyId] = {};
			}
			const existing = state[lobbyId].seenOpenMarketIds || [];
			const updated = Array.from(new Set([...existing, ...marketIds]));
			state[lobbyId].seenOpenMarketIds = updated;
			localStorage.setItem(LOBBY_DETAILS_STORAGE_KEY, JSON.stringify(state));
		},
		setHasSeenInfo: (state: any, action: any) => {
			const { lobbyId } = action.payload;
			if (!state[lobbyId]) state[lobbyId] = {};
			state[lobbyId] = {
				...state[lobbyId],
				hasSeenInfo: true,
			};
			localStorage.setItem(LOBBY_DETAILS_STORAGE_KEY, JSON.stringify(state));
		},

		resetLobbyDetails: () => {
			localStorage.removeItem(LOBBY_DETAILS_STORAGE_KEY);
			return {};
		},
		setSurvivorIntroState: (state: any, action: any) => {
			const { canShowIntro, showModal } = action.payload;

			state.canShowSurvivorIntro = canShowIntro;
			state.showSurvivorIntroModal = showModal;

			localStorage.setItem(LOBBY_DETAILS_STORAGE_KEY, JSON.stringify(state));
		},

		setHasNotSeenInfo: (state: any, action: any) => {
			const { lobbyId } = action.payload;
			if (!state[lobbyId]) state[lobbyId] = {};
			state[lobbyId] = {
				...state[lobbyId],
				hasSeenInfo: false,
			};
			localStorage.setItem(LOBBY_DETAILS_STORAGE_KEY, JSON.stringify(state));
		},

		closeSurvivorIntro: (state: any) => {
			state.showSurvivorIntroModal = false;

			localStorage.setItem(LOBBY_DETAILS_STORAGE_KEY, JSON.stringify(state));
		},
	},
});

export const {
	setLastKnownRank,
	setShouldAnimate,
	setHasSeenInfo,
	setSeenOpenMarketIds,
	resetLobbyDetails,
	setSurvivorIntroState,
	setHasNotSeenInfo,
	closeSurvivorIntro,
} = lobbyDetailsSlice.actions;

export const useLastKnownRankSelector = (lobbyId: any) =>
	useSelector((state: any) => state.lobbyDetails?.[lobbyId]?.lastKnownRank ?? null);

export const useShouldAnimateSelector = (lobbyId: any) =>
	useSelector((state: any) => state.lobbyDetails?.[lobbyId]?.isShouldAnimate ?? false);

export const useSeenOpenMarketIdsSelector = (lobbyId: any) =>
	useSelector((state: any) => state.lobbyDetails?.[lobbyId]?.seenOpenMarketIds ?? []);

export const useHasSeenInfoSelector = (lobbyId: any) =>
	useSelector((state: any) => state.lobbyDetails?.[lobbyId]?.hasSeenInfo);

export const useCanShowSurvivorIntroSelector = () =>
	useSelector((state: any) => state.lobbyDetails?.canShowSurvivorIntro ?? false);

export const useShowSurvivorIntroModalSelector = () =>
	useSelector((state: any) => state.lobbyDetails?.showSurvivorIntroModal ?? false);
